export interface Video {
  id: string;
  title: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  description: string;
  views: string;
  rating: number;
  episodes: string;
  year: string;
  duration: string;
}

export const categories = [
  { name: '电视剧', slug: 'tv-series', icon: 'ri-tv-line' },
  { name: '电影', slug: 'movies', icon: 'ri-film-line' },
  { name: '综艺', slug: 'variety', icon: 'ri-emotion-laugh-line' },
  { name: '动漫', slug: 'anime', icon: 'ri-rocket-line' },
  { name: '纪录片', slug: 'documentary', icon: 'ri-camera-line' },
  { name: '少儿', slug: 'kids', icon: 'ri-hearts-line' },
];

export const allVideos: Video[] = [
  {
    id: 'v1',
    title: '繁花',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20Blossoms%20Shanghai%20poster%20style%20with%20warm%20neon%20lights%20and%20vintage%201990s%20aesthetic%2C%20cinematic%20lighting%2C%20artistic%20composition%2C%20dark%20background%20with%20golden%20accents&width=800&height=450&seq=juzi-video-cover-01&orientation=landscape',
    category: '电视剧',
    categorySlug: 'tv-series',
    description: '九十年代的上海，春风化雨，生机勃勃。阿宝凭借自己的智慧和勇气，在商海中闯出一片天地。',
    views: '1280万',
    rating: 9.3,
    episodes: '30集全',
    year: '2024',
    duration: '45分钟/集',
  },
  {
    id: 'v2',
    title: '流浪地球2',
    coverImage: 'https://readdy.ai/api/search-image?query=sci%20fi%20movie%20poster%20style%20with%20futuristic%20space%20station%20and%20earth%20in%20background%2C%20dramatic%20cinematic%20lighting%2C%20dark%20atmosphere%20with%20blue%20tech%20accents%2C%20epic%20scale&width=800&height=450&seq=juzi-video-cover-02&orientation=landscape',
    category: '电影',
    categorySlug: 'movies',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对重重危机，英雄们挺身而出。',
    views: '3560万',
    rating: 9.1,
    episodes: '1部全',
    year: '2023',
    duration: '173分钟',
  },
  {
    id: 'v3',
    title: '奔跑吧第八季',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20colorful%20vibrant%20energy%2C%20group%20of%20celebrities%20in%20casual%20sportswear%2C%20dynamic%20action%20pose%2C%20bright%20festive%20atmosphere%2C%20dark%20background&width=800&height=450&seq=juzi-video-cover-03&orientation=landscape',
    category: '综艺',
    categorySlug: 'variety',
    description: '全新的奔跑吧第八季，精彩游戏环节再次升级，明星阵容豪华，欢乐不停歇。',
    views: '2100万',
    rating: 8.8,
    episodes: '更新至12期',
    year: '2024',
    duration: '90分钟/期',
  },
  {
    id: 'v4',
    title: '斗罗大陆',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20poster%20with%20martial%20arts%20fantasy%20character%20in%20dynamic%20pose%2C%20magical%20glowing%20effects%2C%20epic%20landscape%20background%2C%20dark%20atmospheric%20tone&width=800&height=450&seq=juzi-video-cover-04&orientation=landscape',
    category: '动漫',
    categorySlug: 'anime',
    description: '唐门外门弟子唐三因偷学内门绝学被追，跳崖明志后来到斗罗大陆，从此开启了一段传奇人生。',
    views: '5200万',
    rating: 9.4,
    episodes: '更新至286集',
    year: '2018-2024',
    duration: '20分钟/集',
  },
  {
    id: 'v5',
    title: '舌尖上的中国第四季',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20poster%20with%20delicious%20traditional%20cuisine%20closeup%2C%20steaming%20hot%20dishes%2C%20warm%20ambient%20lighting%2C%20artistic%20food%20photography%2C%20dark%20rich%20background&width=800&height=450&seq=juzi-video-cover-05&orientation=landscape',
    category: '纪录片',
    categorySlug: 'documentary',
    description: '探寻中国各地美食文化的起源与发展，讲述美食背后的人文故事，展现中华饮食文化的博大精深。',
    views: '890万',
    rating: 9.5,
    episodes: '8集全',
    year: '2024',
    duration: '50分钟/集',
  },
  {
    id: 'v6',
    title: '熊出没之逆转时空',
    coverImage: 'https://readdy.ai/api/search-image?query=cute%203D%20animated%20bears%20movie%20poster%20with%20colorful%20forest%20background%2C%20playful%20cartoon%20style%2C%20bright%20and%20cheerful%20atmosphere%2C%20kids%20friendly%20vibrant%20colors%2C%20dark%20edge%20framing&width=800&height=450&seq=juzi-video-cover-06&orientation=landscape',
    category: '少儿',
    categorySlug: 'kids',
    description: '熊大、熊二和光头强穿越时空，展开一场惊险刺激又充满欢乐的冒险之旅。',
    views: '1800万',
    rating: 8.9,
    episodes: '1部全',
    year: '2024',
    duration: '95分钟',
  },
  {
    id: 'v7',
    title: '狂飙',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20thriller%20poster%20with%20intense%20atmosphere%2C%20two%20men%20facing%20off%2C%20dramatic%20lighting%20with%20shadows%2C%20dark%20gritty%20urban%20background%2C%20cinematic%20composition&width=800&height=450&seq=juzi-video-cover-07&orientation=landscape',
    category: '电视剧',
    categorySlug: 'tv-series',
    description: '一部扫黑除恶的精彩力作，展现了一线刑警与黑恶势力二十年的生死较量。',
    views: '6800万',
    rating: 9.5,
    episodes: '39集全',
    year: '2023',
    duration: '45分钟/集',
  },
  {
    id: 'v8',
    title: '满江红',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20movie%20poster%20with%20ancient%20Chinese%20courtyard%20setting%2C%20red%20lanterns%2C%20mysterious%20atmosphere%2C%20dark%20night%20scene%2C%20cinematic%20suspense%20style&width=800&height=450&seq=juzi-video-cover-08&orientation=landscape',
    category: '电影',
    categorySlug: 'movies',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一群小人物前赴后继，用生命揭开谜案真相。',
    views: '4200万',
    rating: 8.7,
    episodes: '1部全',
    year: '2023',
    duration: '159分钟',
  },
  {
    id: 'v9',
    title: '乘风破浪的姐姐第五季',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20elegant%20women%20in%20stunning%20stage%20costumes%2C%20glamorous%20spotlight%20effect%2C%20purple%20and%20gold%20color%20scheme%2C%20dark%20theater%20background&width=800&height=450&seq=juzi-video-cover-09&orientation=landscape',
    category: '综艺',
    categorySlug: 'variety',
    description: '30+姐姐们再次集结，用实力和魅力征服舞台，展现女性力量与美丽。',
    views: '3100万',
    rating: 8.6,
    episodes: '更新至10期',
    year: '2024',
    duration: '120分钟/期',
  },
  {
    id: 'v10',
    title: '三体',
    coverImage: 'https://readdy.ai/api/search-image?query=sci%20fi%20drama%20poster%20with%20mysterious%20cosmic%20phenomenon%2C%20three%20body%20problem%20visual%20representation%2C%20dark%20space%20background%20with%20technological%20elements%2C%20atmospheric%20tension&width=800&height=450&seq=juzi-video-cover-10&orientation=landscape',
    category: '电视剧',
    categorySlug: 'tv-series',
    description: '纳米科学家汪淼被警官史强带入联合作战中心，潜入神秘组织"科学边界"，揭开三体世界的秘密。',
    views: '4500万',
    rating: 8.9,
    episodes: '30集全',
    year: '2023',
    duration: '45分钟/集',
  },
  {
    id: 'v11',
    title: '深海',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%20with%20dreamy%20underwater%20world%2C%20colorful%20coral%20reef%20and%20jellyfish%2C%20magical%20atmosphere%2C%20dark%20deep%20sea%20background%2C%20artistic%20animation%20style&width=800&height=450&seq=juzi-video-cover-11&orientation=landscape',
    category: '动漫',
    categorySlug: 'anime',
    description: '一个少女在神秘海底世界展开奇幻冒险，画面绚丽震撼，情感真挚动人。',
    views: '1600万',
    rating: 9.0,
    episodes: '1部全',
    year: '2023',
    duration: '112分钟',
  },
  {
    id: 'v12',
    title: '地球脉动第三季',
    coverImage: 'https://readdy.ai/api/search-image?query=nature%20documentary%20poster%20with%20stunning%20wildlife%20photography%2C%20majestic%20animals%20in%20natural%20habitat%2C%20epic%20landscape%2C%20dramatic%20natural%20lighting%2C%20dark%20rich%20background&width=800&height=450&seq=juzi-video-cover-12&orientation=landscape',
    category: '纪录片',
    categorySlug: 'documentary',
    description: '用最先进的拍摄技术记录地球上最壮观的自然奇观和野生动物生存故事。',
    views: '750万',
    rating: 9.7,
    episodes: '8集全',
    year: '2023',
    duration: '60分钟/集',
  },
];

export const getVideosByCategory = (slug: string): Video[] => {
  if (slug === 'all') return allVideos;
  return allVideos.filter((v) => v.categorySlug === slug);
};